import { useMutation, useQueryClient } from 'react-query';
import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useAlerts from '@/hooks/useAlerts';

export function showConfirm(t, description, onOk, title = '') {
  Modal.confirm({
    title: title ? t(title) : t('deleteConfirmation'),
    icon: <ExclamationCircleOutlined />,
    content: description,
    onOk
  });
}

const useCrud = (service, keyList, keyOne, customFeedBack = null, customErrorFeedBack = null) => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const { putErrorCode } = useAlerts();

  const { mutateAsync: create, isLoading: isCreating } = useMutation(service?.save,
    {
      onSuccess: ({ data }) => {
        queryClient.invalidateQueries(keyList);
        customFeedBack ? customFeedBack(data, 'createSuccess') : message.success(t('createSuccess'));
      },
      onError: (e) => {
        customErrorFeedBack ? customErrorFeedBack(e) : putErrorCode(e);
      }
    });

  const { mutateAsync: update, isLoading: isUpdating, isSuccess: isUpdatingSuccess, reset: updatingReset} = useMutation(service?.update,
    {
      onSuccess: ({ data }) => {
        customFeedBack ? customFeedBack(data, 'updateSuccess') : message.success(t('updateSuccess'));
        queryClient.invalidateQueries(keyList);
        queryClient.invalidateQueries(keyOne);
        queryClient.invalidateQueries(data?._id);
      },
      onError: (e) => {
        customErrorFeedBack ? customErrorFeedBack(e) : putErrorCode(e);
      }
    });

  const { mutateAsync: remove, isLoading: isRemoving } = useMutation(service?.delete,
    {
      onSuccess: ({ data }) => {
        customFeedBack ? customFeedBack(data, 'deleteSuccess') : message.success(t('deleteSuccess'));
        queryClient.invalidateQueries(keyList);
      },
      onError: (e) => {
        customErrorFeedBack ? customErrorFeedBack(e) : putErrorCode(e);
      }
    }
  );

  return {
    create,
    isCreating,
    update,
    isUpdating,
    remove,
    isRemoving,
    isUpdatingSuccess,
    updatingReset,
    isLoading: isCreating || isUpdating || isRemoving
  };
};

export default useCrud;
